import React from 'react';
import { EDITOR_COPY } from './editorCopy';
import { filterSlash } from './tiptap/slash';

/**
 * The slash menu panel (prototype `wkSlashStyle` / `wkSlashRows`), positioned
 * under the caret inside the surface's `position:relative` wrapper. Rows pick
 * on mousedown (preventDefault keeps the caret in the surface).
 */
export default function WikiSlashMenu({ slash, x = 0, y = 0, onPick }) {
    if (!slash || !slash.open) return null;
    const items = filterSlash(slash.q);
    return (
        <div
            className="wk-ed-slash"
            role="listbox"
            aria-label="Insert"
            data-testid="wiki-editor-slash"
            style={{ left: `${x}px`, top: `${y}px` }}
        >
            <div className="wk-ed-slash-head">{EDITOR_COPY.slashHeader}</div>
            {items.map(([label, kind, hint], i) => (
                <div
                    key={kind}
                    role="option"
                    aria-selected={i === slash.pick}
                    className={`wk-ed-slash-row${i === slash.pick ? ' is-active' : ''}`}
                    data-testid={`wiki-editor-slash-${kind}`}
                    onMouseDown={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        onPick(kind);
                    }}
                >
                    <span className="wk-ed-slash-label">{label}</span>
                    <code className="wk-ed-slash-hint">{hint}</code>
                </div>
            ))}
            {!items.length && <div className="wk-ed-slash-empty">{EDITOR_COPY.slashEmpty}</div>}
        </div>
    );
}
